
<template>
  <div>
    <b-row v-for="(item, index) in customerInfo" :key="index" class="mb-1">
      <b-col cols="4" class="d-flex justify-content-between mb-2">
        {{ item.label }} <span>:</span>
      </b-col>
      <b-col cols="8">
        {{ item.value }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'CustomerInfo',
  data() {
    return {
      customerInfo: [
        { label: 'Company Name', value: 'PT. Kaltim Prima Coal, Tbk' },
        { label: 'Website', value: 'kpc.co.id' },
        { label: 'Email', value: 'info@kpc.co.id' },
        { label: 'Country', value: 'Indonesia' },
        { label: 'Province', value: 'DKI Jakarta' },
        { label: 'City', value: 'Jakarta Selatan' },
        { label: 'Address', value: 'Jl. Jendral Sudirman Kav 10–11' },
        { label: 'NPWP', value: '317.4050.10.7930.00.1' },
        { label: 'PIC', value: 'Septian David Maulana' },
      ],
    }
  },
}
</script>
